import { WelcomeScreen } from '../pages/WelcomeScreen';

/**
 * The index route, shared with the Home integration tests so they mount whatever the app mounts at `/`.
 * Not lazy like the other route files: it is the first screen, and a Suspense gap would precede the loading page.
 */
export const homeRoute = {
  index: true,
  element: <WelcomeScreen />,
} as const;
